export const cardRules = {
    name: [
      { required: true, message: "请输入", trigger: "change" },
    ],
    type: [
      { required: true, message: "请选择", trigger: "change" },
    ],
    price: [
      { required: true, message: "请输入", trigger: "change" },
    ],
    duration: [
        { required: true, message: "请输入", trigger: "change" },
      ],
    
  }
  
  